import { useQuery } from 'hooks/useQuery'

import { fetchDiscoverContent } from 'utils/queries'

import { DiscoverContent } from 'types/discoverContent'

export const useDiscoverContent = () => {
  return useQuery<DiscoverContent>(['discoverContent'], () => fetchDiscoverContent())
}
